import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { useNavigate, useParams } from "@tanstack/react-router";
import { useAuditPlanDetailQuery } from "../api/queries";
import {
  AuditPlanDetailTour,
  useAuditPlanDetailTour,
} from "../tour/AuditPlanDetailTour";
import { AuditPlanDetailView } from "../ui/AuditPlanDetailView";

export function AuditPlanDetailPage() {
  const { id } = useParams({ from: "/app/internal-audit/$id" });
  const nav = useNavigate({ from: "/app/internal-audit/$id" });
  const navToOther = useNavigate();
  const auditPlan = useAuditPlanDetailQuery(id);
  const canEdit = useActionPermission(["internal_audit:update"]);
  const canCreateRecord = useActionPermission(["internal_audit:create"]);
  const tour = useAuditPlanDetailTour();

  const handleDownloadPDF = () => {
    if (auditPlan.data) {
      nav({
        to: "/app/internal-audit/$id/pdf-preview",
        params: { id: auditPlan.data.id },
      });
    }
  };

  const handleCreateRecord = () => {
    if (auditPlan.data) {
      navToOther({
        to: "/app/internal-audit/records/new/$planId",
        params: { planId: auditPlan.data.id },
      });
    }
  };

  if (auditPlan.isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex items-center justify-center py-12">
            <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
          </div>
        </Main>
      </>
    );
  }

  if (!auditPlan.data) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex items-center justify-center py-12">
            <p className="text-muted-foreground">ບໍ່ພົບຜະແນການກວດສອບ</p>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />

      <Main>
        <AuditPlanDetailTour
          run={tour.run}
          onCallback={tour.handleJoyrideCallback}
        />
        <AuditPlanDetailView
          auditPlan={auditPlan.data}
          onEdit={() => nav({ to: `/app/internal-audit/${id}/edit` })}
          onDownloadPDF={handleDownloadPDF}
          onCreateRecord={handleCreateRecord}
          canEdit={!!canEdit}
          canCreateRecord={!!canCreateRecord}
          startTour={tour.startTour}
        />
      </Main>
    </>
  );
}
